import * as React from 'react';
import company from '../company';
import LegalPage, { LegalSection } from '../components/LegalPage';

const sections: LegalSection[] = [
  {
    title: 'Quem somos',
    blocks: [
      `${company.name}, inscrita no CNPJ sob o nº ${company.cnpj} ("EasyCart", "nós"), é a controladora dos dados pessoais tratados no aplicativo, no site e nas lojas autônomas que opera ou disponibiliza a seus parceiros.`,
      `Qualquer dúvida sobre esta política pode ser encaminhada pelos canais indicados na seção de contato, ao final deste documento.`,
    ],
  },
  {
    title: 'Dados que coletamos',
    blocks: [
      'Coletamos apenas os dados necessários para permitir o acesso às lojas, concluir as compras e manter a segurança da operação:',
      [
        {
          label: 'Dados cadastrais',
          text: 'nome, CPF, data de nascimento, e-mail e telefone informados no momento do cadastro.',
        },
        {
          label: 'Dados de pagamento',
          text: 'informações necessárias para processar a transação. Os dados completos do cartão são coletados e armazenados diretamente pelas instituições financeiras e provedores de pagamento; nós recebemos apenas informações como bandeira, últimos dígitos e o resultado da autorização.',
        },
        {
          label: 'Dados transacionais',
          text: 'produtos adquiridos, valores, data, hora e loja em que a compra foi realizada.',
        },
        {
          label: 'Dados de uso e do dispositivo',
          text: 'identificador do aparelho, modelo, sistema operacional, versão do aplicativo, endereço IP, registros de acesso e páginas ou telas visitadas.',
        },
        {
          label: 'Dados de localização',
          text: 'quando você autoriza o acesso no dispositivo, para indicar as lojas mais próximas e liberar a entrada na unidade.',
        },
        {
          label: 'Imagens de segurança',
          text: 'as lojas autônomas podem contar com sistemas de monitoramento por câmeras, sinalizados no local, utilizados exclusivamente para segurança patrimonial e prevenção a perdas.',
        },
        {
          label: 'Atendimento',
          text: 'mensagens, solicitações e registros de contato enviados por você aos nossos canais de suporte.',
        },
      ],
    ],
  },
  {
    title: 'Para que usamos os seus dados',
    blocks: [
      'Tratamos dados pessoais para as seguintes finalidades:',
      [
        'criar e administrar a sua conta e autenticar o seu acesso às lojas;',
        'processar compras, pagamentos, estornos e emitir documentos fiscais;',
        'prestar atendimento, responder solicitações e resolver problemas;',
        'prevenir fraudes, perdas e usos indevidos da plataforma, garantindo a segurança de clientes e lojas;',
        'melhorar produtos e serviços, por meio de análises estatísticas e métricas de uso;',
        'enviar comunicações operacionais (como confirmações de compra) e, mediante o seu consentimento, comunicações promocionais;',
        'cumprir obrigações legais, regulatórias e ordens de autoridades competentes.',
      ],
      'O tratamento se apoia nas bases legais previstas na Lei nº 13.709/2018 (LGPD), especialmente a execução do contrato, o cumprimento de obrigação legal ou regulatória, o legítimo interesse e, quando exigido, o consentimento do titular.',
    ],
  },
  {
    title: 'Compartilhamento de dados',
    blocks: [
      'Não vendemos dados pessoais. O compartilhamento ocorre apenas quando necessário, com:',
      [
        'instituições financeiras, adquirentes e provedores de meios de pagamento, para processar as transações;',
        'fornecedores de tecnologia, hospedagem em nuvem, analytics e suporte que atuam como operadores, seguindo nossas instruções;',
        'parceiros responsáveis pela operação das lojas em que a compra é realizada, limitado ao necessário;',
        'autoridades públicas, judiciais ou administrativas, quando houver requisição legal ou para exercício regular de direitos.',
      ],
      'Exigimos de todos os parceiros a adoção de medidas de segurança e o uso dos dados restrito às finalidades contratadas.',
    ],
  },
  {
    title: 'Cookies e tecnologias semelhantes',
    blocks: [
      'Utilizamos cookies e identificadores semelhantes para manter a sessão ativa, lembrar preferências, medir audiência e melhorar a experiência de navegação. Você pode bloquear ou apagar cookies nas configurações do navegador, ciente de que algumas funcionalidades podem deixar de funcionar corretamente.',
    ],
  },
  {
    title: 'Armazenamento e prazo de retenção',
    blocks: [
      'Os dados são armazenados em ambientes controlados, podendo ser hospedados em servidores no Brasil ou no exterior. Mantemos os dados pelo tempo necessário ao cumprimento das finalidades desta política e, após esse período, pelos prazos exigidos por obrigações legais, fiscais e regulatórias ou para o exercício regular de direitos. Encerrados os prazos, os dados são eliminados ou anonimizados.',
      'Quando houver transferência internacional de dados, adotamos as salvaguardas previstas na LGPD para assegurar nível de proteção adequado.',
    ],
  },
  {
    title: 'Segurança da informação',
    blocks: [
      'Adotamos medidas técnicas e administrativas para proteger os dados contra acessos não autorizados, perda, alteração ou divulgação indevida, incluindo controle de acesso, criptografia em trânsito e monitoramento dos sistemas. Nenhum sistema é totalmente imune a incidentes; caso ocorra um incidente de segurança relevante, comunicaremos os titulares e a Autoridade Nacional de Proteção de Dados nos termos da legislação.',
    ],
  },
  {
    title: 'Direitos do titular',
    blocks: [
      'Nos termos do art. 18 da LGPD, você pode solicitar a qualquer momento:',
      [
        'a confirmação da existência de tratamento e o acesso aos seus dados;',
        'a correção de dados incompletos, inexatos ou desatualizados;',
        'a anonimização, o bloqueio ou a eliminação de dados desnecessários ou tratados em desconformidade com a lei;',
        'a portabilidade dos dados a outro fornecedor;',
        'a eliminação dos dados tratados com base no consentimento, ressalvadas as hipóteses de guarda obrigatória;',
        'informação sobre o compartilhamento de dados com terceiros;',
        'a revogação do consentimento e informação sobre as consequências dessa revogação.',
      ],
      'As solicitações podem ser feitas pelos canais de contato indicados abaixo e podem exigir a confirmação da sua identidade antes do atendimento.',
    ],
  },
  {
    title: 'Crianças e adolescentes',
    blocks: [
      'A plataforma é destinada a maiores de 18 anos. Não coletamos intencionalmente dados de crianças e adolescentes sem o consentimento específico de ao menos um dos pais ou do responsável legal. Identificado um cadastro nessas condições, a conta poderá ser encerrada e os dados eliminados.',
    ],
  },
  {
    title: 'Alterações desta política',
    blocks: [
      'Esta política pode ser atualizada para refletir mudanças legais, técnicas ou de negócio. A versão vigente é sempre a publicada nesta página, com a data da última atualização indicada no topo. Alterações relevantes serão comunicadas pelos nossos canais.',
    ],
  },
  {
    title: 'Contato',
    blocks: [
      `Para exercer seus direitos ou esclarecer dúvidas sobre o tratamento de dados pessoais, fale com o nosso encarregado pelo tratamento de dados (DPO) pelo e-mail ${company.email} ou pelo telefone ${company.phone}.`,
    ],
  },
];

export default function PrivacyPolicy() {
  return (
    <LegalPage
      title="Política de Privacidade"
      documentTitle={`Política de Privacidade | ${company.name}`}
      intro={`Esta Política de Privacidade explica como a ${company.name} coleta, utiliza, compartilha e protege dados pessoais de clientes e visitantes, em conformidade com a Lei Geral de Proteção de Dados (Lei nº 13.709/2018) e demais normas aplicáveis. Ao utilizar nosso aplicativo, site ou lojas, você declara estar ciente das práticas descritas aqui.`}
      sections={sections}
    />
  );
}
